import { render } from "./popularScience.vue?vue&type=template&id=79aacd68&scoped=true"
import script from "./popularScience.vue?vue&type=script&lang=js"
export * from "./popularScience.vue?vue&type=script&lang=js"

import "./popularScience.vue?vue&type=style&index=0&id=79aacd68&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79aacd68"]])

export default __exports__